import URI from 'urijs';

var RegisterToVote = function () {
    var RegisterToVote = {
        votingInformationUrl: null,
        $requestAdvocateInformationForm: null,
        pdf: {
            ajaxCall: null,
            readyInterval: null
        }
    };

    RegisterToVote.init = function() {
        $(function() {
            var $civicActionCenterNotRegisteredModal = $('#civicActionCenterNotRegisteredModal');
            var $paperRegistrationForm = $('#paper-registration-form');
            var $completedRegistrationFormContainer = $('#completed-registration-form-container');
            RegisterToVote.$requestAdvocateInformationForm = $('#request-advocate-information-form');

            $('[data-toggle="tooltip"]').tooltip();

            $('.submit-button-container .submit-button', $paperRegistrationForm).click(function() {
                var $me = $(this);
                var $submitWaitingMessage = $('.submit-waiting-message', $paperRegistrationForm);

                RegisterToVote.hideFormError();
                window.P2A.Helpers.Ajax.loadingStarted($me);
                $submitWaitingMessage.show();

                var uri = '/' + window.P2A.CivicActionCenter.shortUrl + '/civicactioncenter/registertovote/paper';
                uri += '?id=' + $('[name="id"]', $paperRegistrationForm).val();
                var params = {
                    method: 'POST'
                };

                params.data = window.P2A.Helpers.Forms.SerializeToObject($paperRegistrationForm.serializeArray());

                var onSuccess = function(returnData) {
                    if (returnData.error) {
                        window.P2A.Helpers.Ajax.loadingCompleted($me, false);
                        $('.submit-waiting-message', $paperRegistrationForm).hide();
                        RegisterToVote.showFormError(returnData.error);
                        return false;
                    } else {
                        //Wait 2 seconds for RTV to get a head start on generating the PDF
                        setTimeout(function () {
                            window.P2A.Helpers.Ajax.loadingCompleted($me, false);
                            window.location.href = returnData.redirectTo;
                            $submitWaitingMessage.hide();
                        }, 5000);
                    }
                    return false;
                };
                var onError = function(w, t, f) {
                    $('.submit-waiting-message', $paperRegistrationForm).hide();
                    window.P2A.Helpers.Ajax.loadingCompleted($me, false);
                };
                window.P2A.Helpers.Ajax.send(uri, params, onSuccess, onError);
            });

            //Store when a user has gone to register online, and then redirect them to the voting information page
            $('.register-online', $civicActionCenterNotRegisteredModal).click(function() {
                var uri = '/' + window.P2A.CivicActionCenter.shortUrl + '/civicactioncenter/registertovote/logstep';
                uri += '?id=' + window.P2A.CivicActionCenter.encryptedId;
                var params = {
                    method: 'POST'
                };
                params.data = {
                    step: 'register-online'
                };
                window.P2A.Helpers.Ajax.send(uri, params);

                setTimeout(function() {
                    window.location.href = RegisterToVote.votingInformationUrl;
                }, 100);

                return true;
            });

            $completedRegistrationFormContainer.on('click', '.mail-it-submit', function() {
                var $me = $(this);

                window.P2A.Helpers.Ajax.loadingStarted($me);
                $me.blur();

                var uri = '/' + window.P2A.CivicActionCenter.shortUrl + '/civicactioncenter/registertovote/paper/mailit';
                uri += '?id=' + $('[name="id"]', $completedRegistrationFormContainer).val();
                var params = {
                    method: 'POST'
                };

                params.data = {
                    pdfUrl: $('.link-to-pdf-reg-form', $completedRegistrationFormContainer).attr('href')
                };

                var onSuccess = function(returnData) {
                    var $mailItCompletedDescription = $('.mail-it-completed-description', $completedRegistrationFormContainer);
                    window.P2A.Helpers.Ajax.loadingCompleted($me, false);

                    $me.hide();

                    if (returnData.error) {
                        var message = '<div class="alert alert-danger">';
                        message += returnData.error;
                        message += '</div>';
                        $mailItCompletedDescription.html(message);
                        $mailItCompletedDescription.show(400);

                        return false;
                    } else {
                        if (returnData.expectedDeliveryDate) {
                            $('.expected-delivery-date-date', $mailItCompletedDescription).html(returnData.expectedDeliveryDate);
                            $('.expected-delivery-date', $mailItCompletedDescription).show();
                        }
                        $mailItCompletedDescription.show(400);
                    }
                    return false;
                };
                var onError = function(w, t, f) {
                    window.P2A.Helpers.Ajax.loadingCompleted($me, false);
                };
                window.P2A.Helpers.Ajax.send(uri, params, onSuccess, onError);

                return false;
            });
        });
    };

    RegisterToVote.displayNotRegisteredToVote = function(data) {
        //If no OVR and no Paper, just give them the URls
        if (data.noRegistrationMessage) {
            var $civicActionCenterNoRegistrationModal = $('#civicActionCenterNoRegistrationModal');
            $('.message', $civicActionCenterNoRegistrationModal).html(data.noRegistrationMessage);
            $civicActionCenterNoRegistrationModal.modal('show');
        } else {
            window.P2A.CivicActionCenter.RegisterToVote.showNotRegisteredChoices(data.stateRegistrationInfo, data.paperRegistrationUrl, data.registerToVoteExclamation);
            window.P2A.CivicActionCenter.RegisterToVote.votingInformationUrl = data.votingInformationUrl;
        }
    };

    RegisterToVote.showNotRegisteredChoices = function(stateRegInfo, paperRegistrationUrl, modalTitleText) {
        var $civicActionCenterNotRegisteredModal = $('#civicActionCenterNotRegisteredModal');
        var advState = window.P2A.CivicActionCenter.states[stateRegInfo.stateAbbr];

        //Make it "the" District of Columbia
        if (stateRegInfo.stateAbbr === 'DC') {
            advState = 'the ' + advState;
        }
        $('.not-registered-state', $civicActionCenterNotRegisteredModal).html(advState);
        if (stateRegInfo.registrationUrl) {
            $('.register-online', $civicActionCenterNotRegisteredModal).attr('href', stateRegInfo.registrationUrl);
        } else {
            $('.modal-title', $civicActionCenterNotRegisteredModal).html(modalTitleText);
            $('.register-online', $civicActionCenterNotRegisteredModal).hide();
        }
        $('.register-paper', $civicActionCenterNotRegisteredModal).attr('href', paperRegistrationUrl);
        var $modalFooter = $('#sos-link-container');
        if (stateRegInfo.electionInfoUrl) {
            $('.sos-link', $modalFooter).attr('href', stateRegInfo.electionInfoUrl);
            $modalFooter.show();
        } else {
            $modalFooter.hide();
        }

        $(".registration-reset").on("click", function(event) {
            event.preventDefault()
            var uri = new URI()
            uri.setSearch({action: "checkregistration", resetcookie: 1})
            window.location = uri
        })

        $civicActionCenterNotRegisteredModal.modal('show');
    };

    RegisterToVote.showPdfReady = function() {
        var $completedRegistrationFormContainer = $('#completed-registration-form-container');
        var $linkToPdfRegForm = $('.link-to-pdf-reg-form', $completedRegistrationFormContainer);
        $linkToPdfRegForm.html(window.P2A.CivicActionCenter.actionsInfo.regFormButtonText + ' <span class="button-icon-container"><i class="fa fa-download"></i></span>');
        $linkToPdfRegForm.removeAttr('disabled');
        $linkToPdfRegForm.prop('disabled', false);
        $('.submit-waiting-message', $completedRegistrationFormContainer).hide();

        //Show the "mail it to me" option
        $('.mail-it-container', $completedRegistrationFormContainer).show();
    };

    RegisterToVote.showFormError = function (errormessage) {
        var $alertContainer = $('#paper-registration-form-container .alert-container');
        if ($('.alert-danger', $alertContainer).length <= 0) {
            var message = '<div class="alert alert-danger" style="display: none;">';
            message += errormessage;
            message += '</div>';

            $alertContainer.prepend(message);
            //Ease it in
            $('.alert-danger', $alertContainer).show(function() {
                var $me = $(this);
                $('html, body').animate({
                    scrollTop: $me.offset().top
                }, 400);
            });
        } else {
            $('.alert-danger', $alertContainer).html(errormessage);
            //Ease it in
            $('.alert-danger', $alertContainer).show(function() {
                var $me = $(this);
                $('html, body').animate({
                    scrollTop: $me.offset().top
                }, 400);
            });
        }
    };

    RegisterToVote.hideFormError = function(errormessage) {
        var $alertContainer = $('#paper-registration-form-container .alert-container');
        var $alertDanger = $('.alert-danger', $alertContainer);
        $alertDanger.html('');
        $alertDanger.hide();
    };

    return RegisterToVote;
};

export default RegisterToVote;
